import bigcommerceMergeToCard from 'util/bigcommerce-merge-to-card';
import magentoMergeToCard from 'util/magento-merge-to-card';
import otherMergeToCard from 'util/other-merge-to-card';
import sapHybrisMergeToCard from 'util/sap-hybris-merge-to-card';
import shopifyMergeToCard from 'util/shopify-merge-to-card';

import { useState } from 'react';

import { useBasket } from 'context/basket-context';
import { useStoreDetails } from 'context/store-context';

export const useProductExpert = () => {
  const [cartError, setCartError] = useState<string>();

  const { cartItems, merge } = useBasket();
  const { storeType, mergeToCart, basket } = useStoreDetails();

  const onClickCheckout = async (callback?: () => void) => {
    if (basket.mergeToCart === false) {
      callback && callback();
      return;
    }

    if (callback?.name === 'close' && cartItems.length === 0) {
      callback && callback();
      return;
    }

    const newItems = cartItems.filter((item) => !item.mergedToCart);
    if (callback?.name === 'close' && newItems.length === 0) {
      callback && callback();
      return;
    }
    try {
      switch (storeType) {
        case 'SHOPIFY':
          await shopifyMergeToCard(newItems);
          await merge(newItems);
          break;
        case 'BIGCOMMERCE':
          await bigcommerceMergeToCard(newItems);
          await merge(newItems);
          break;
        case 'MAGENTO':
          await magentoMergeToCard(newItems, mergeToCart?.path?.trim());
          await merge(newItems);
          break;
        case 'SAMSUNG':
        case 'SAP_HYBRIS':
          await sapHybrisMergeToCard(newItems);
          await merge(newItems);
          break;
        default:
          await otherMergeToCard(mergeToCart, newItems);
          await merge(newItems);
      }
    } catch (error) {
      console.error((error as Error).message);
      setCartError((error as Error).message);
    } finally {
      callback && callback();
    }
  };

  return {
    cartError,
    onClickCheckout,
    setCartError
  };
};
